import * as React from "react";
import { Alert } from "@amzn/awsui-components-react";

export const ContentEvaluationDisclaimer: React.FC = () => {
    return (
        <Alert
            type="info"
            header="DISCLAIMER"
        >
            <p>
                This tool is designed to assist in reviewing content against certain guidance on Pathfinder, but should not be relied upon without human review. By proceeding, you acknowledge and agree to the following:
            </p>
            <ul>
                <li>All output from this tool must be reviewed for accuracy and compliance by a human reviewer.</li>
                <li>You remain responsible for reviewing and drafting your document in compliance with all relevant legal guidance.</li>
                <li>Do not input sensitive or personal information into this tool.</li>
            </ul>
        </Alert>
    );
};
